import axios from "axios";

// Varsayilan canli adres. Yerelde denemek icin frontend kokunde .env.local acip
// REACT_APP_API_URL=http://localhost:5000 yazmak yeterli (canli build etkilenmez).
export const base_URL =
  process.env.REACT_APP_API_URL || "https://htc.htcmuhendislik.com.tr";
const api = axios.create({
  baseURL: base_URL + "/api",
});

// Her istekte token'ı otomatik ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("fieldToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Oturum sonlandiginda (401) otomatik cikis.
//
// Sunucu, suresi dolmus veya gecersiz token icin 401 doner. Rol yetersizligi
// ise 403'tur ve cikis yaptirmaz - sadece o istek reddedilir.
//
// Ayni anda birden fazla istek 401 alabildigi icin tek seferlik bayrak
// kullaniliyor; aksi halde ust uste yonlendirme yapiliyordu.
let oturumKapatiliyor = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const durum = error.response?.status;

    if (durum === 401 && !oturumKapatiliyor) {
      oturumKapatiliyor = true;

      const kod = error.response?.data?.code;
      const mesaj =
        kod === "TOKEN_EXPIRED"
          ? "Oturum süreniz doldu. Lütfen tekrar giriş yapın."
          : "Oturumunuz sonlandı. Lütfen tekrar giriş yapın.";

      localStorage.removeItem("fieldUser");
      localStorage.removeItem("fieldToken");

      // Kullanici neden cikis yaptigini gorsun; sessizce bos ekran kalmasin.
      try {
        window.alert(mesaj);
      } catch (e) {}

      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default api;
